// extracted by mini-css-extract-plugin
export default {"melodyVideo":"LJ-z","isFullWidth":"MJ-z","landingPageVideo":"NJ-z","play":"OJ-z","iframeVideo":"PJ-z","playHidden":"QJ-z","fullwidth":"RJ-z"};